import { FilterOutlined, WechatOutlined } from '@ant-design/icons';

import { Page, RecordModal } from '@app/components';
import type { NPage } from '@app/components/Page/types/Page.main';
import {
  DATA_TESTID_ATTRIBUTE,
  NO_TOOLTIP_TITLE,
  RIGHTS_LEADS,
} from '@app/constants';
import { Leads, LeadsFunnels, LeadCardPage } from '@app/pages';
import {
  LeadCardPageBackButton,
  LeadCardPageHeader,
} from '@app/pages/Leads/LeadCardPage';
import { RecordModalProvider } from '@app/providers';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NNavigation } from '@app/types';

import {
  LEADS_PAGE_KEY,
  LEADS_PAGE_PATH,
  LEADS_PAGE_TITLE,
  SALES_FUNNELS_LEADS_KEY,
  SALES_FUNNELS_LEADS_PATH,
  SALES_FUNNELS_LEADS_TITLE,
  SALES_FUNNELS_LEAD_CARD_PATH,
  LEAD_CARD_KEY,
  LEAD_CARD_PATH,
  LEAD_CARD_TITLE,
} from './constants';

const leadsLevelData: NPage.LevelDataModel = {
  title: generateSpanWithDataTestId(LEADS_PAGE_TITLE, 'leads-page'),
  path: LEADS_PAGE_PATH,
};

const salesFunnelsLevelData: NPage.LevelDataModel = {
  title: generateSpanWithDataTestId(
    SALES_FUNNELS_LEADS_TITLE,
    'sales-funnels-leads-page'
  ),
  path: SALES_FUNNELS_LEADS_PATH,
};

export const leadsPages: NNavigation.Main = [
  {
    key: LEADS_PAGE_KEY,
    icon: <WechatOutlined />,
    label: LEADS_PAGE_TITLE,
    [DATA_TESTID_ATTRIBUTE]: LEADS_PAGE_KEY,
    id: LEADS_PAGE_KEY,
    path: LEADS_PAGE_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page
        hideBackButton
        disableBreadcrumbs
        mobileTitle="Лиды"
        headerContent={<Leads.Header />}
      >
        <Leads.Page />
      </Page>
    ),
    issidebaritem: 'true',
    servicerightsid: RIGHTS_LEADS,
    sidebarparentid: LEADS_PAGE_KEY,
  },
  {
    key: SALES_FUNNELS_LEADS_KEY,
    label: SALES_FUNNELS_LEADS_TITLE,
    id: SALES_FUNNELS_LEADS_KEY,
    [DATA_TESTID_ATTRIBUTE]: SALES_FUNNELS_LEADS_KEY,
    path: SALES_FUNNELS_LEADS_PATH,
    title: NO_TOOLTIP_TITLE,
    icon: <FilterOutlined />,
    element: (
      <Page
        disableBreadcrumbs
        hideBackButton
        mobileTitle="Лиды"
        headerContent={<LeadsFunnels.Header />}
        contentLayoutClassName="leads-list-content-layout"
      >
        <LeadsFunnels.Page />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_LEADS,
    sidebarparentid: SALES_FUNNELS_LEADS_KEY,
  },
  {
    key: `${LEAD_CARD_KEY}-sales-funnels`,
    label: LEAD_CARD_TITLE,
    pagebreadcrumbdatatestid: 'new-chats-page',
    pagetitledatatestid: 'new-chats-title',
    id: `${LEAD_CARD_KEY}-sales-funnels`,
    path: SALES_FUNNELS_LEAD_CARD_PATH,
    element: (
      <Page
        hideBackButton
        headerContent={<LeadCardPageHeader />}
        headerNavigationContent={<LeadCardPageBackButton />}
        secondLevelData={salesFunnelsLevelData}
        contentLayoutClassName="lead-card-content-layout"
        disableContentStyles
      >
        <RecordModalProvider>
          <LeadCardPage />
          <RecordModal />
        </RecordModalProvider>
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SALES_FUNNELS_LEADS_KEY,
  },
  {
    key: LEAD_CARD_KEY,
    label: LEAD_CARD_TITLE,
    pagebreadcrumbdatatestid: 'new-chats-page',
    pagetitledatatestid: 'new-chats-title',
    id: LEAD_CARD_KEY,
    path: LEAD_CARD_PATH,
    element: (
      <Page
        hideBackButton
        headerContent={<LeadCardPageHeader />}
        headerNavigationContent={<LeadCardPageBackButton />}
        secondLevelData={leadsLevelData}
        contentLayoutClassName="lead-card-content-layout"
        disableContentStyles
      >
        <RecordModalProvider>
          <LeadCardPage />
          <RecordModal />
        </RecordModalProvider>
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: LEADS_PAGE_KEY,
  },
];
